class GuideDropdown extends HTMLElement {
  private selectElement: HTMLSelectElement | null = null;
  private contentItems: NodeListOf<HTMLElement> | null = null;

  connectedCallback() {
    // Query elements only when connected to the DOM
    this.selectElement = this.querySelector(".guide-dropdown__select");
    this.contentItems = this.querySelectorAll(".guide-dropdown__content-item");

    if (!this.selectElement) {
      console.error("GuideDropdown: Could not find select element.");
      return; // Stop if select element is missing
    }
    if (!this.contentItems || this.contentItems.length === 0) {
      console.warn("GuideDropdown: Could not find any content items. Dropdown might not function as expected.");
      // Proceeding without content items might be acceptable if dynamically loaded,
      // but in this case, it indicates a potential setup issue.
    }

    this.selectElement.addEventListener("change", this.handleSelectionChange.bind(this));

    // Set initial visibility based on the currently selected option
    this.setInitialVisibility();
  }

  disconnectedCallback() {
    // Clean up event listener
    if (this.selectElement) {
      this.selectElement.removeEventListener("change", this.handleSelectionChange.bind(this));
    }
  }

  private handleSelectionChange(event: Event) {
    // Ensure elements are still available before proceeding
    if (!this.selectElement || !this.contentItems) {
      console.error("GuideDropdown: Elements not found during selection change.");
      return;
    }

    const selectedHandle = (event.target as HTMLSelectElement).value;

    this.contentItems.forEach((item) => {
      const itemHandle = item.dataset.handle;

      if (itemHandle === selectedHandle) {
        item.hidden = false;
      } else {
        item.hidden = true;
      }
    });
  }

  private setInitialVisibility() {
    // Ensure elements are available before proceeding
    if (!this.selectElement || !this.contentItems) {
      console.error("GuideDropdown: Elements not found during initial visibility setup.");
      return;
    }
    const initialSelectedHandle = this.selectElement.value;

    this.contentItems.forEach((item) => {
      const itemHandle = item.dataset.handle;

      if (itemHandle === initialSelectedHandle) {
        item.hidden = false;
      } else {
        item.hidden = true;
      }
    });
  }
}

customElements.define("guide-dropdown", GuideDropdown);
